import React from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import Occasion from '@repo/utils/helpers/Occasion';
import sharedStyles from '../WelcomeGuide.module.scss';
import styles from './Explore.module.scss';
import ActivityListItem from '@views/Activity/ActivityListItem';
import { selectActivity } from '@repo/redux/reducers/data/activity';
import { ActivityItem } from '@repo/utils/models/Activity';

const now = Date.now() / 1000;
const timings = [
  new Occasion(now - 60 * 60 * 1.6),
  new Occasion(now - 60 * 60 * 4.3),
  new Occasion(now - 60 * 60 * 8.12),
];

const fallbackActivityItems = [
  new ActivityItem({
    type: 'birthday',
    metadata: {
      contact: {
        displayName: 'Jeremy Haas',
        firstName: 'Jeremy',
        avatar_url: 'https://static-exp1.licdn.com/sc/h/244xhbkr7g40x6bsu4gi6q4ry',
      },
    },
    date: timings[1],
  }),
  new ActivityItem({
    type: 'news',
    metadata: {
      contact: {
        displayName: 'Ursula Quinn',
        firstName: 'Ursula',
        avatar_url: 'https://static-exp1.licdn.com/sc/h/244xhbkr7g40x6bsu4gi6q4ry',
      },
      link: 'https://clay.earth',
      title: 'Talking to Infants Boosts Cognition',
      outlet: 'JAMA',
    },
    date: timings[2],
  }),
];

export default function Explore({ onClick }) {
  const activity = useSelector(selectActivity);
  let items = activity.sortedItems.filter((item) => item.type !== 'announcement').slice(0, 3);

  if (items.length < 3) {
    items = fallbackActivityItems;
  }

  return (
    <div className={cn(sharedStyles.page, sharedStyles.numberedPage)} onClick={onClick}>
      <div className={styles.exploreUI}>
        {items.map((item) => (
          <div key={item.id} className={styles.activityItemContainer}>
            {/* <FeedItemDisplay className={styles.feedItem} item={item} /> */}
            <ActivityListItem item={item} selected={false} />
          </div>
        ))}
      </div>
      <div className={cn(sharedStyles.pageContent, sharedStyles.right)}>
        <h2>Home</h2>
        <p>Home is a high-level view of what's happening in your network, in real-time.</p>
        <p>
          Clay's Home view helps you take a more proactive approach to fostering your relationships.
          New job? Recent move? Published article? We help you stay on top of those updates, big and
          small.
        </p>
      </div>
      <div className={sharedStyles.pageNumber}>04 — Home</div>
    </div>
  );
}
